export function getOnLine() {
    return typeof navigator !== 'undefined' && typeof navigator.onLine === 'boolean'
        ? navigator.onLine
        : false
}

export function getConnection() {
    if (typeof navigator === 'undefined') {
        return
    }

    return navigator.connection || navigator.mozConnection || navigator.webkitConnection
}
